import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, watchEffect } from "../../../adapter-vue";
import { isWeChat } from "../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    show: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    }
  },
  emits: ['update:show'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var showMask = ref(false);
    watchEffect(function () {
      showMask.value = props.show;
    });
    var emit = __emit;
    var toggleView = function toggleView() {
      showMask.value = !showMask.value;
      emit('update:show', showMask.value);
    };
    return function (_ctx, _cache) {
      return _unref(showMask) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "mask",
        onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
          return !_unref(isWeChat) && toggleView;
        }, ["self"]))
      }, [_renderSlot(_ctx.$slots, "default")])) : _createCommentVNode("", true);
    };
  }
});